import { render } from "./CardEtatEmp.vue?vue&type=template&id=53816778"
import script from "./CardEtatEmp.vue?vue&type=script&lang=ts"
export * from "./CardEtatEmp.vue?vue&type=script&lang=ts"
script.render = render

export default script